<template>
  <div v-if="isShow" :id="'inventoryAddProductModal' + name">
    <b-modal
      v-model="isShow"
       id="addproduct-modal"
      ref="addproduct-modal"
      class="p-0"
      size="lg"
      hide-header
      hide-footer
      centered
    >
      <div class="header-purple">
        <p class="font-weight-bold mb-0">รายการเพิ่มสินค้า</p>
      </div>
      <div class="container-list-inventory">
        <b-container class="px-0">
          <div class="d-flex flex-row no-gutters">
            <b-input-group class="panel-input-serach">
              <b-form-input
                class="input-serach"
                placeholder="ค้นหาชื่อสินค้า, SKU, คอลเลคชั่นสินค้า"
                v-model="filterInventoryList.search"
                :id="'inventory' + name + 'AddProductSearch'"
                v-on:keyup.13="enterFilter"
              ></b-form-input>
              <b-input-group-prepend>
                <span class="icon-input m-auto pr-2">
                  <font-awesome-icon icon="search" title="View" />
                </span>
              </b-input-group-prepend>
            </b-input-group>
            <div>
              <InventoryFilter
                :name="'AddProduct'+name"
                v-on:onSubmitFilter="onSubmitFilter"
                ref="inventoryFilter"
              />
            </div>
          </div>

          <b-row class="no-gutters my-3">
            <b-col md="4"> รายการสินค้า </b-col>
            <b-col class="text-md-right mt-2 mt-md-0 text-black-50" md="8">
              แสดงผลลัพธ์ {{ items.length }} รายการ
            </b-col>
          </b-row>
          <div class="list-inventory">
            <b-table
              class="text-center table-list mb-0 bg-white"
              responsive
              :items="items"
              :fields="fields"
              :busy="isBusy"
              show-empty
              empty-text="ไม่พบข้อมูล"
              thead-class="d-none"
            >
              <template #cell(productId)="data">
                <div>
                  <b-form-checkbox
                    :id="'addProductInventory'+ name +'Checkbox'+ data.item.productId"
                    name="productCb"
                    :value="data.item.productId"
                    v-model="listIdSelected"
                    :disabled="data.item.stockStatus == 'หมด'"
                    @change="checkProduct(data.item)"
                  ></b-form-checkbox>
                  <!-- @change="checkProduct(data.item)" -->
                </div>
              </template>

              <template #cell(imageUrl)="data">
                <div>
                  <div class="position-relative picture-text">
                    <div
                      class="square-box b-contain"
                      v-bind:style="{
                        'background-image': 'url(' + data.item.imageUrl + ')',
                      }"
                    ></div>
                  </div>
                </div>
              </template>

              <template #cell(productName)="data">
                <div class="text-left align-middle">
                  <p class="mb-0">{{ data.item.sku }}</p>
                  <p class="text-black-50 mb-0">{{ data.item.productName }}</p>
                  <b-badge
                    v-if="data.item.stockStatus == 'หมด'"
                    pill
                    variant="danger"
                    class="px-3 text-white"
                    >หมด</b-badge
                  >
                  <b-badge
                    v-if="data.item.stockStatus == 'เหลือน้อย'"
                    pill
                    variant="warning"
                    class="px-3 text-white"
                    >เหลือน้อย</b-badge
                  >
                </div>
              </template>
            </b-table>
          </div>
        </b-container>
      </div>
      <b-row class="no-gutters px-3 px-sm-0 bg-white" v-if="!isBusy">
        <b-col
          class="form-inline justify-content-center justify-content-sm-end"
        >
          <div class="d-sm-flex m-3">
            <b-pagination
              v-model="filterInventoryList.page"
              :total-rows="rows"
              :per-page="filterInventoryList.pageSize"
              class="m-md-0 page-item"
              @change="pagination"
            ></b-pagination>
          </div>
          <b-form-select
            class="mr-sm-3 select-page"
            v-model="filterInventoryList.pageSize"
            @change="handleChangePerpage"
            :options="pageOptions"
          ></b-form-select>
        </b-col>
      </b-row>
      <div class="container-footer">
        <b-button
          class="btn-main-2"
          @click="closeModal"
          :id="'cancleInventoryAddProduct'+name"
          >ยกเลิก</b-button
        >
        <b-button
          class="btn-main"
          @click="addProduct"
          :id="'saveInventoryAddProduct'+name"
          >เพิ่มสินค้า</b-button
        >
      </div>
    </b-modal>
  </div>
</template>

<script>
import InventoryFilter from "../../inventory-filter/InventoryFilter.vue";

export default {
  components: {
    InventoryFilter,
  },
  props: {
    name: {
      required: false,
      type: String,
    },
    listId: {
      required: false,
      type: Array,
    },
  },
  data: function() {
    return {
      isShow: false,
      items: [],
      fields: [
        {
          key: "productId",
          label: "",
          class: "w-40px text-nowrap",
        },
        {
          key: "imageUrl",
          label: "",
          class: "w-70px text-nowrap",
        },
        {
          key: "productName",
          label: "",
          class: "w-100px text-nowrap",
        },
      ],
      productSelected: [],
      rows: 0,
      isBusy: false,
      filterInventoryList: {
        search: "",
        productInventoryTypes: [],
        productStatus: [],
        categories: [0, 0, 0, 0],
        stockStatus: [3],
        StartDate: "",
        EndDate: "",
        page: 1,
        pageSize: 10,
        collections: "",
      },
      rows: 0,
      pageOptions: [
        { value: 10, text: "10 / หน้า" },
        { value: 30, text: "30 / หน้า" },
        { value: 50, text: "50 / หน้า" },
        { value: 100, text: "100 / หน้า" },
      ],
      listIdSelected: [],
    };
  },
  async created() {
    // await this.getFilter();
    this.getProductList();
  },
  watch: {
    isShow: function() {
      if (this.isShow) {
        this.listIdSelected = this.listId;
      }
    },
  },
  methods: {
    getFilter() {
      if (this.$route.query.search) {
        this.filterInventoryList.search = this.$route.query.search;
      }
      if (this.$route.query.productInventoryTypes) {
        this.filterInventoryList.productInventoryTypes = this.$route.query.productInventoryTypes;
      }
      if (this.$route.query.productStatus) {
        this.filterInventoryList.productStatus = this.$route.query.productStatus;
      }
      if (this.$route.query.categories) {
        this.filterInventoryList.categories = this.$route.query.categories;
      }
      if (this.$route.query.stockStatus) {
        this.filterInventoryList.stockStatus = this.$route.query.stockStatus;
      }
      if (this.$route.query.StartDate) {
        this.filterInventoryList.StartDate = this.$route.query.StartDate;
      }
      if (this.$route.query.EndDate) {
        this.filterInventoryList.EndDate = this.$route.query.EndDate;
      }
      if (this.$route.query.page) {
        this.filterInventoryList.page = parseInt(this.$route.query.page) || 1;
      }
      if (this.$route.query.pageSize) {
        this.filterInventoryList.pageSize =
          parseInt(this.$route.query.pageSize) || 10;
      }
    },
    setFilter() {
      return;
      // this.$router
      //   .push({
      //     path: "/inventory",
      //     query: {
      //       brandID: this.$route.query.brandID,
      //       search: this.filterInventoryList.search,
      //       productInventoryTypes: this.filterInventoryList
      //         .productInventoryTypes,
      //       productStatus: this.filterInventoryList.productStatus,
      //       categories: this.filterInventoryList.categories,
      //       stockStatus: this.filterInventoryList.stockStatus,
      //       StartDate: this.filterInventoryList.StartDate || "",
      //       EndDate: this.filterInventoryList.EndDate || "",
      //       pageSize: this.filterInventoryList.pageSize,
      //       page: this.filterInventoryList.page,
      //       tab: this.$route.query.tab || 1
      //     },
      //   })
      //   .catch((err) => {});
    },
    addProduct() {
      this.$emit("add-product", this.productSelected, this.listIdSelected);
      this.closeModal();
      this.productSelected = [];
    },
    checkProduct(item) {
      const index = this.productSelected.indexOf(item);
      if (index > -1) {
        this.productSelected.splice(index, 1);
      } else {
        this.productSelected.push(item);
      }
      // console.log(JSON.stringify(this.productSelected));
    },
    closeModal() {
      this.isShow = false;
    },
    openModal() {
      this.isShow = true;
    },
    unCheckProduct(listIdDelete) {
      for (let x in listIdDelete) {
        if (this.listIdSelected.includes(listIdDelete[x])) {
          let index = this.listIdSelected.indexOf(listIdDelete[x]);
          if (index != -1) {
            this.listIdSelected.splice(index, 1);
          }
        }
      }
    },
    onSubmitFilter(filter) {
      this.setFilter();
      this.getProductList(filter);
    },
    getProductList(filter) {
      if (filter) {
        this.filterInventoryList.search = filter.search;
        this.filterInventoryList.productInventoryTypes =
          filter.productInventoryTypes;
        this.filterInventoryList.productStatus = filter.productStatus;
        this.filterInventoryList.categories = filter.categories;
        this.filterInventoryList.stockStatus = filter.stockStatus;
        this.filterInventoryList.pageSize = filter.perPage;
        this.filterInventoryList.page = filter.page;
        this.filterInventoryList.collections = filter.collections;
        this.filterInventoryList.StartDate = filter.StartDate;
        this.filterInventoryList.EndDate = filter.EndDate;
      }

      this.isBusy = true;
      this.axios
        .post(
          `${this.$baseUrl}/stockdistribute/product/list`,
          this.filterInventoryList
        )
        .then((data) => {
          this.rows = data.detail.totalCount;
          this.items = data.detail.data;
          this.isBusy = false;
        });
    },
    enterFilter(event) {
      console.log(`event`, event);
      if (event.which === 13) {
        this.getProductList();
      }
    },
    handleChangePerpage(value) {
      this.filterInventoryList.page = 1;
      this.filterInventoryList.pageSize = value;
      this.setFilter();
      this.getProductList();
    },
    pagination(Page) {
      this.filterInventoryList.page = Page;
      this.setFilter();
      this.getProductList();
    },
  },
};
</script>

<style lang="scss" scoped>
.list-inventory {
  border: 1px solid #bcbcbc;
  padding-left: 8px;
  padding-right: 8px;
  border-radius: 8px;
  overflow-y: scroll;
  height: 40vh;
}
.container-list-inventory {
  padding: 1rem 1rem 0rem 1rem;
}
.container-footer {
  padding: 0rem 1rem 1rem 1rem;
  display: flex;
  justify-content: space-between;
}
.list-item {
  padding: 8px;
}

.list-item:not(:last-child) {
  border-bottom: 1px solid #bcbcbc;
}

.img-container {
  width: 80px;
  height: 80px;
}

.btn-filter-custom {
  background-color: white !important;
  color: #5b57a5 !important;
  width: 100%;
  white-space: nowrap;
  border-color: #5b57a5 !important;
}

.btn-filter-custom:hover {
  border-color: #5b57a5 !important;
}
/deep/ .table td {
  border-bottom: 0.5px solid #ccc !important;
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}
.picture-text {
  min-width: 80px;
}
</style>
